// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Eqmf","label":"styles_label__1Wx29"};